<div class="street-light-planner-step2">
  <p class="label questio">{{ 'module.energyMap.streetlightPlanner.step2HeaderText' | translate }}</p>

  <div class="budget">
    <button class="btn btn-outline-primary" [class.-disabled]="!isBudget">
      {{ budget | number: '' : 'es' }}{{ 'module.energyMap.streetlightPlanner.step2BudgetUnitText' | translate }}
    </button>
    <app-custom-tooltip class="app-custom-tooltip" [class.-disabled]="!isBudget" [html]="budgetHtml"></app-custom-tooltip>
  </div>

  <mat-slider
    class="mat-slider -hide-track"
    [class.-disabled]="!isBudget"
    [disabled]="!isBudget"
    [step]="step"
    [min]="minPrice"
    [max]="maxPrice"
    [(ngModel)]="budget"
    tickInterval="1"
    (change)="budgetChange.emit(budget)"
  ></mat-slider>

  <button class="btn btn-outline-primary" [class.-disabled]="!isBudget">
    <div class="price-range">
      <div class="col1">{{ minPrice | number: '' : 'es' }}{{ 'module.energyMap.streetlightPlanner.step2BudgetUnitText' | translate }}</div>
      <div class="col2">{{ maxPrice / 2 | number: '' : 'es' }}{{ 'module.energyMap.streetlightPlanner.step2BudgetUnitText' | translate }}</div>
      <div class="col3">{{ maxPrice | number: '' : 'es' }}{{ 'module.energyMap.streetlightPlanner.step2BudgetUnitText' | translate }}</div>
    </div>
  </button>

  <div class="selection">
    <button class="btn btn-primary" [class.-active]="!isBudget" (click)="toggleBudget()">
      {{ 'module.energyMap.streetlightPlanner.step2NoBudgetText' | translate }}
    </button>
    <app-custom-tooltip class="app-custom-tooltip" [html]="budgetChoiceHtml"></app-custom-tooltip>
  </div>
</div>
